export const theme = {
  colors: {
    primaryGreen: 'rgb(30, 126, 52)',
    secondaryGreen: 'rgb(72, 168, 90)',
    primaryOrange: 'rgb(255, 140, 0)',
    primaryWhite: 'rgb(250, 250, 250)',
    primaryGray: 'rgb(36, 36, 36)',
  },
  fonts: {
    primary: "'Poppins', sans-serif",
  },
};

export const primaryGreen = theme.colors.primaryGreen;
export const secondaryGreen = theme.colors.secondaryGreen;
export const primaryWhite = theme.colors.primaryWhite;
export const primaryOrange = theme.colors.primaryOrange;
export const primaryGray = theme.colors.primaryGray;
